import * as Sentry from "@sentry/react";
import Cookies from 'js-cookie'

const useSubmitContactMessage = () => {
    return async (fields, recaptchaToken) => {
        const formData = new FormData();
        
        Object.keys(fields).forEach(key => {
            switch (key) {
                case 'subject':
                    if (true) {
                        formData.set('subject', fields.subject.value);
                    }
                    break
                case 'messageBody':
                    if (true) {
                        formData.set('message', fields.messageBody.value);
                    }
                    break
                case 'email':
                    if (true) {
                        formData.set('email', fields.email.value);
                    }
                    break
                default:
                    break
            }
        });

        formData.set('g_recaptcha', recaptchaToken)

        const additionalHeaders = {}

        const csrfTokenCookie = Cookies.get('csrftoken')

        if (csrfTokenCookie) {
            additionalHeaders['X-CSRFToken'] = csrfTokenCookie
        }

        // document.cookie.split(';').find((val) => {
        //     if (val.includes('csrftoken')) {
        //         additionalHeaders['X-CSRFToken'] = val.split('=')[1]
        //     }
        // })

        let response;
        
        try {
            response = await fetch(
                `${process.env.REACT_APP_API_URL}/contact/`,
                {
                    method: 'POST',
                    headers: {
                        'Access-Control-Request-Method': 'POST',
                        ...additionalHeaders
                    },
                    body: formData
                }
            );
        } catch (error) {
            console.log(error);
            Sentry.captureException(error);
            error.clientStatusMessage = {
                variant: 'danger',
                i18nKey: 'error.api-connection-timeout',
                source: `${error.message}`
            }
            throw error;
        }

        let parsedResponse;
        try {
            parsedResponse = await response.json();
        } catch (error) {
            Sentry.captureException(error);
            error.clientStatusMessage = {
                variant: 'danger',
                i18nKey: 'error.api-bad-response',
                source: `${response.status} ${response.statusText}`
            }
            throw error;
        }

        if (response.status !== 201) {
            const error = new Error();
            switch (response.status) {
                case 400:
                case 415:
                    error.clientStatusMessage = {
                        variant: 'danger',
                        i18nKey: 'error.client-bad-request',
                        source: `${response.status.toString()} ${parsedResponse.detail}`
                    }
                    Sentry.captureException(parsedResponse);
                    break;
                default:
                    error.clientStatusMessage = {
                        variant: 'danger',
                        i18nKey: 'error.api-bad-response',
                        source: `${response.status.toString()} ${parsedResponse.detail}`
                    }
                    Sentry.captureException(parsedResponse);
            }
            throw error;
        }

        return parsedResponse;
    }
}

export default useSubmitContactMessage;
